<template>
  <div v-if="isEnabled" class="vue timparty-aspira-fisso-mobile bg-dark text-white text-center py-5" id="fisso-mobile">
    <LoaderOverlay v-if="loading"/>
    <div class="row mx-2">
      <div class="col-lg-12 text-center row no-gutters justify-content-lg-center">
        <div class="col-12">
          <h1 class="text-white mb-4 p-1">Se hai Fisso e Mobile di TIM sei sempre più premiato</h1>
        </div>
<!--        <div class="col-12 col-lg-3 py-2 px-2 card-aspira">-->
<!--          <div class="col-12 bg-white text-black text-left h-100 p-0">-->
<!--            <div class="col-12 h-25 row pt-3">-->
<!--              <div class="col-3">-->
<!--                <img :src="themePath('images/icona_gioca_e_vinci.png')" alt="" class="icon-image">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-12 h-50">-->
<!--              <h3>GIOCA e VINCI</h3>-->
<!--              <p>-->
<!--                Per tutti i concorsi di TIM Party hai <strong>5 giocate al giorno</strong> per vincere premi esclusivi.-->
<!--              </p>-->
<!--            </div>-->
<!--            <div class="h-25 col-8" style="top: 5%">-->
<!--              <a href="/gioca-e-vinci" class="btn btn-lg btn-primary btn-block no-border">SCOPRI</a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="col-12 col-lg-3 py-2 px-2 card-aspira">
          <div class="col-12 bg-white text-black text-left h-100 p-0">
            <div class="col-12 h-25 row pt-3">
              <div class="col-3">
                <img :src="themePath('images/icona_party_domenica.png')" alt="" class="icon-image">
              </div>
            </div>
            <div class="col-12 h-50">
              <h3>PARTY della DOMENICA</h3>
              <p>
                Ogni domenica appuntamento imperdibile con la fortuna. Per te <strong>5 tentativi per vincere</strong> bellissimi premi.
              </p>
            </div>
            <div class="h-25 col-8" style="top: 5%">
              <a :href="party_dom_url" class="btn btn-lg btn-primary btn-block no-border">SCOPRI</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3 py-2 px-2 card-aspira">
          <div class="col-12 bg-white text-black text-left h-100 p-0">
            <div class="col-12 h-25 row pt-3">
              <div class="col-3">
                <img :src="themePath('images/icona_vantaggi.png')" alt="" class="icon-image">
              </div>
            </div>
            <div class="col-12 h-50">
              <h3>VANTAGGI</h3>
              <p>
                Ancora più vantaggi, <strong>offerte esclusive</strong> sui migliori Brand e <strong> sconti dedicati.</strong>
              </p>
            </div>
            <div class="h-25 col-8" style="top: 5%">
              <a href="/vantaggi" class="btn btn-lg btn-primary btn-block no-border">SCOPRI</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3 py-2 px-2 card-aspira" v-if="party_moments">
          <div class="col-12 bg-white text-black text-left h-100 p-0">
            <div class="col-12 h-25 row pt-3">
<!--              <div class="col-12">-->
<!--                <img :src="themePath('images/icona_party_moments.png')" alt="" class="icon-image-large img-fluid">-->
<!--              </div>-->
              <div class="col-3">
                <img :src="themePath('images/icona_party_moments_1.png')" alt="" class="icon-image img-fluid">
              </div>
              <div class="col-3">
                <img :src="themePath('images/icona_party_moments_2.png')" alt="" class="icon-image img-fluid">
              </div>
              <div class="col-3">
                <img :src="themePath('images/icona_party_moments_3.png')" alt="" class="icon-image img-fluid">
              </div>
              <div class="col-3">
                <img :src="themePath('images/icona_party_moments_4.png')" alt="" class="icon-image img-fluid">
              </div>
            </div>
            <div class="col-12 h-50">
              <h3>PARTY MOMENTS</h3>
              <p>
                Solo per te <strong>esclusive esperienze 2x1</strong> per momenti unici da condividere.
              </p>
            </div>
            <div class="h-25 col-8" style="top: 5%">
              <a href="/geo/vantaggi" class="btn btn-lg btn-primary btn-block no-border">SCOPRI</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 text-center row no-gutters justify-content-lg-center">
        <div class="col-lg-4 col-12 p-2">
          <btn class="btn btn-block btn-lg text-white border-white" @click.prevent="modal.show = true">
            DIVENTA CLIENTE FISSO E MOBILE
          </btn>

          <basic-modal :modal-id="'mdl-aspirazionalita'" modalClass="modal-lg" :show="modal.show" v-on:modalClose="modal.show = false">

            <div class="modal-body p-5">
              <div class="text-center my-3">
              </div>

              <div>
                <div class="text-center my-4">
                  <h3 class="text-dark mt-2 font-weight-bold">Come diventare cliente Fisso e Mobile</h3>
                </div>

                <div class="text-left">
                  <p class="text-black">Per avere subito il massimo ed essere un cliente di tipologia Fisso e Mobile, basta avere almeno una di queste caratteristiche:</p>
                  <ul class="text-black">
                    <li>avere sia una linea fissa sia una mobile TIM intestata allo stesso codice
                      fiscale;</li>
                    <li>avere una linea mobile prepagata su cui sia attiva l’offerta TIM
                      100%, TIM UNICA, o un’offerta della gamma TIM Smart o TIM
                      Connect o TIM Super;</li>
                    <li>avere una linea mobile abbonata.</li>
                  </ul>

<!--                  <p class="text-left text-black-50">-->
<!--                    ¹ le offerte TIM Vision considerate: TIMVISION MOBILE, Promo TIMvision, 5€, Promo APP TIMvision, Cubovision TV, Cubovision calcio 7 gg, Try&Buy cubovision, Try&Buy cubovision tablet, Nuovo Pack TIM Vision Chromecast, TIMvision CRM, TIMVISION PER TE, TIMvision Retention, TIMVISION SEMPRE CON TE, Timvision per iPhone, Timvision per Neomobile.-->
<!--                  </p>-->
                </div>

                <div class="text-center my-4">
                  <button class="btn btn-lg btn-primary no-border" v-on:click="modal.show = false">CHIUDI</button>
                </div>
              </div>

            </div>

          </basic-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import BasicModal    from "@/components/BasicModal";
import LoaderOverlay from "@/components/LoaderOverlay";
import moment        from "moment/moment";
import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: "AspiraFissoMobile",
  components: {
    LoaderOverlay,
    BasicModal
  },
  mixins: [TimPartyMixin],
  props: {
    endPartyMoments: {
      type: String,
      default: '20221122' // YYYYMMDD,
    }
  },
  data: function () {
    return {
      party_dom_url: '',
      party_moments: false,
      modal: {
        id: 'modal-badges-info',
        show: false,
        class_name: 'modal-sm',
        error: null,
        state: null,
      },
    };
  },
  mounted: function () {
  },
  methods: {
    getPartyDom: function(){
      var self = this;
      this.setApiUrl(this.user.endpoints.contest);

      var payload = {
        action: 'getAllActive',
        access_token: this.access_token,
      };

      self.loading = true;
      this.callApi( payload, function( response){

        self.loading = false;

        if(response.data != undefined){
          var contests = response.data;

          for (let contest in contests) {
            if (Object.hasOwn(contests, contest)) {
              let obj = contests[contest];
              if (obj.code.match(/PARTY_DOM_.*/)) {
                self.party_dom_url = obj.extra.url
                return;
              }
            }

          }
        }
      });
    },

    getPartyMoments: function(){
      var self = this;

      // let endDateString = url.searchParams.has('endDate') ? url.searchParams.get('endDate') : self.endPartyMoments;
      let endDateString = self.endPartyMoments;
      // Party moments off at 2022-12-01
      let endDate = moment(self.endPartyMoments, 'YYYYMMDD')
      endDate.hour(23).minute(59).second(59);
      let today = moment();

      if(today.isAfter(endDate)) {
        self.party_moments = false;
        return;
      }

      this.setApiUrl(this.user.endpoints.catalog);

      var payload = {
        action: 'getPartyMoments',
        access_token: this.access_token,
      };

      self.loading = true;
      this.callApi( payload, function( response){
        self.loading = false;

        if(response != undefined){
          let partyMoments = response;

          for (let partyMoment in partyMoments) {
            if (Object.hasOwn(partyMoments, partyMoment)) {
              let obj = partyMoments[partyMoment];
              if (obj.profilePromo.match(/FISSO E MOBILE.*/)) {
                self.party_moments = true;
                return;
              }
            }

          }
        }
      });
    },
  },
  watch: {
    user: function () {
      this.getPartyDom();
      this.getPartyMoments();
    },
    party_dom_url: function() {
    },
    party_moments: function() {
    },
  },
  computed: {
    isEnabled: function(){
      return ( this.user.cluster && this.user.cluster != 'GUEST_STAR' && this.user.enable_user_cluster);
    },
  },
}
</script>
